import './styles.scss'
import PropTypes from 'prop-types'
import { useState } from 'react'

const SearchField = function ({ placeholderText, onInput, onClear }) {
  const [value, setValue] = useState('')
  const onInputHandler = (event) => {
    setValue(event.target.value)
    onInput(event)
  }
  return (
    <div className="search-field">
      <span className="search-icon"></span>
      <input
        value={value}
        onInput={onInputHandler}
        placeholder={placeholderText}
        type="text"
      />
      {
        value && <span
          onClick={() => {
            setValue('')
            onClear()
          }}
          className="close-icon"
        />
      }
    </div>
  )
}

SearchField.propTypes = {
  placeholderText: PropTypes.string.isRequired,
  onInput: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
}

export default SearchField
